import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ScheduleService } from '../../shared/services/schedule.service';
import { DaySlotsHash } from '../../shared/models/schedule/day-slots-hash.interface';
import { SessionService } from '../../shared/services/session.service';
import { Location } from '../../shared/models/location.model';
import { Utils } from '../../shared/utils/utils';
import { ModalService } from '../../shared/modals/modal.service';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { AppointmentService } from '../../shared/services/appointment.service';
import { CalendarFilterEvent } from '../../shared/models/calendar-filter-event.model';

import * as moment from 'moment-timezone';
import mainMoment from 'moment';
import { environment } from '../../../environments/environment';
import * as timeZoneIds from '../../../assets/timezoneIds.json';

declare var $:any;

@Component({
    templateUrl: 'select-date.component.html',
    standalone: false
})
export class SelectDateComponent implements OnInit, AfterViewInit {

    public month1: Date;
    public month2: Date;
    public highlightDate: Date;
    public locationSchedule: DaySlotsHash;
    public numApptFilter: number;
    public selectedDate: Date;
    public location: Location;

    public numAvailable: string = '';
    public numNotAvailable: string = '';

    public timeZones: any;
    public isRemoteLocation = false;

    constructor(private scheduleService: ScheduleService,
                private spinnerService: SpinnerService,
                private sessionService: SessionService,
                private translate: TranslateService,
                private modalService: ModalService,
                private appointmentService: AppointmentService,
                private router: Router,
                private changeDetector: ChangeDetectorRef) {
        this.month1 = new Date();
        this.month2 = new Date();
        this.addMonth(this.month2);
        this.numApptFilter = 1;
    }

    ngAfterViewInit(): void {
        // this.timeZones = moment.tz.names();
        const timeZoneArr: any = (timeZoneIds as any).default;
        this.timeZones = timeZoneArr;
    }

    ngOnInit() {
        this.spinnerService.show();

        if (this.sessionService.locationID === environment.REMOTE_LOCATION_ID) {
            this.isRemoteLocation = true;
        }

        Utils.scrollUp();
        this.appointmentService.getSoonestAvailableAppointment(this.sessionService.location.id).subscribe(
            date => {
                if (this.sessionService.numberOfAppointments !== null && this.sessionService.numberOfAppointments !== 0) {
                    this.numApptFilter = this.sessionService.numberOfAppointments;
                }

                let startDate: Date;

                 if (this.sessionService.filterDate !== null) {
                    startDate = new Date(this.sessionService.filterDate);
                } else if (date) {
                    startDate = date;
                } else {
                    startDate = new Date(this.month1.toISOString());
                }
                this.onJumpToDate(startDate);
                this.spinnerService.hide();
            }, error => {
                // silent failure
                this.onJumpToDate(new Date(this.month1.toISOString()));
                this.spinnerService.hide();
            });

        this.location = this.sessionService.location;
        if (this.sessionService.appointmentDate) {
            this.highlightDate = this.selectedDate = this.sessionService.appointmentDate;
        }

        if (this.location.id === environment.REMOTE_LOCATION_ID) {
            this.location.tzData = moment.tz.guess();
            this.isRemoteLocation = true;
        }

        var self: SelectDateComponent = this;

        // set up the date picker popout control
        this.translate.get('SCHEDULE_INTERVIEW.DATE.GO_TO_DATE').subscribe(
            res => {
                let label = res;
                let popoverTemplate = '<div class="popover" role="tooltip"><div class="arrow"></div>' +
                                    //    '<h3 class="popover-header"></h3>' + 
                                      '<div class="popover-body"></div></div>';
                let contentTemplate = '<input id="goToDate" type="text" class="form-control date-widget-field">';
                $('.fa-calendar').popover({
                    sanitize: false,
                    placement: 'left',
                    trigger: 'click',
                    html: true,
                    title: "Go to Date",
                    template: popoverTemplate,
                    content: contentTemplate
                });
                $('.fa-calendar').on('shown.bs.popover', function () {
                    $('.date-widget-field').datepicker({
                        // The input filed sometimes renders initially top left of page. So manually calculate
                        // the calendar offet.
                        beforeShow : function(input,inst) {
                            let popoverInputWidth =  $('.bs-popover-left').width() + 4; 
                            let offset = $('.fa-calendar').offset();

                            offset.left = offset.left - popoverInputWidth;
                            var height = $('.fa-calendar').height() + 4;
                            window.setTimeout(function () {
                                $(inst.dpDiv).css({ top: (offset.top + height) + 'px', left:offset.left + 'px' })
                            }, 1);
                        },

                        // changeMonth: true,
                        // changeYear: true,
                        onSelect: function(date: any) {
                            self.onPopoverDateSelected(date);
                            $('.date-widget-field').datepicker('hide');
                            $('.fa-calendar').focus();
                            $('.fa-calendar').popover('hide');
                        },
                        onClose: function () {
                            $('.fa-calendar').popover('hide');
                        }
                    });
                    
                    $('.date-widget-field').focus();
                    $('.date-widget-field').click();
                });

                // $.extend($.datepicker,{_checkOffset:function(inst,offset,isFixed){return offset}});
            }
        );
        this.setTranslation();
        this.translate.onLangChange.subscribe((change: any) => {
            this.setTranslation();
        });

        $(window).on('resize orientationchange', function(){
            var $elActive = $(document.activeElement);
            if( $elActive.is('.hasDatepicker') ){
                $elActive.datepicker('widget').position({
                    my: 'left top',
                    at: 'left bottom',
                    of: $elActive
                });
            }
        });
    }

    public triggerCalendar() {
        $('.fa-calendar').click();
    }

    protected showDatepicker() {
        $('#date-picker-widget').datepicker('show');
    }

    /**
     * Advances the date on the calander
     */
    public nextMonth() {
        this.addMonth(this.month1);
        this.addMonth(this.month2);
        this.month1 = new Date(this.month1.toISOString());
        this.month2 = new Date(this.month2.toISOString());
        this.refreshSchedule();
    }

    /**
     * Decremetns the calendar to the previous month
     */
    public prevMonth() {
        this.subtractMonth(this.month1);
        this.subtractMonth(this.month2);
        this.month1 = new Date(this.month1.toISOString());
        this.month2 = new Date(this.month2.toISOString());
        this.refreshSchedule();
    }

    public onDateSelected(selectedDate: Date) {
        this.selectedDate = new Date(selectedDate.toISOString());
        this.sessionService.appointmentDate = selectedDate;
    }

    protected onJumpToDate(jumpDate: Date) {
        this.month1 = new Date(jumpDate.toISOString());
        this.month2 = new Date(jumpDate.toISOString());
        this.addMonth(this.month2);
        this.month2 = new Date(this.month2.toISOString());
        this.highlightDate = new Date(jumpDate.toISOString());
        this.refreshSchedule();
    }

    protected onJumpToAppt() {
        let soonest: Date;
        for(let key in this.locationSchedule) {
            let date = key.replace(/([-])+/g, '/');
            if (!soonest && this.locationSchedule[key].totalRemainingAppointements >= this.numApptFilter) {
                soonest = new Date(date);
            } else {
                if (Utils.CompareDates(soonest, new Date(date)) < 0 &&
                    this.locationSchedule[key].totalRemainingAppointements >= this.numApptFilter) {
                    soonest = new Date(date);
                }
            }
        }
        if (soonest) {
            this.onJumpToDate(soonest);
        } else {
            this.translate.get('SCHEDULE_INTERVIEW.DATE.NO_APPOINTMENTS_FOUND', {value: this.numApptFilter}).subscribe(
                (res: string) => {
                    this.modalService.alert(res);
                }
            );
        }
    }

    public onFilterCalendar(event: CalendarFilterEvent) {
        this.numApptFilter = null;
        this.numApptFilter = event.numAppts;
        if (event.soonest) {
            this.getSoonestAppointment();
        }
        this.setTranslation();
    }

    public refreshSchedule() {
        this.spinnerService.show();
        let startDate = new Date(this.month1.toISOString());
        startDate.setDate(28);
        this.subtractMonth(startDate);
        let endDate = new Date(this.month2.toISOString());
        endDate.setDate(1);
        this.addMonth(endDate);
        this.scheduleService.getScheduleSlots(this.sessionService.location, startDate, endDate, this.sessionService.service)
            .subscribe(res => {
                this.locationSchedule = res;
                for(let key in this.locationSchedule) {
                    this.locationSchedule[key].timezone = this.location.tzData;
                    this.locationSchedule[key].slots.forEach(slot => {
                        let startTime = new Date(moment.tz(slot.startTimestamp, this.location.tzData).tz('UTC').format());
                        let now = new Date(moment.tz(Date.now(), 'UTC').format());
                        // if the slot is not expired but the time has passed lets expire it.
                        if (startTime.getTime() < now.getTime() && !slot.expired) {
                            slot.expired = true;
                            this.locationSchedule[key].totalRemainingAppointements -= slot.available;
                        } else if (startTime.getTime() > now.getTime() && slot.expired) {
                            slot.expired = false;
                            this.locationSchedule[key].totalRemainingAppointements += slot.available;
                        }
                    });
                }
                this.spinnerService.hide();
            },
            error => {
                this.spinnerService.hide();
            });
    }

    private getSoonestAppointment() {
        this.spinnerService.show();
        this.appointmentService.getSoonestAvailableAppointment(this.sessionService.location.id)
            .subscribe(soonest => {
                if (soonest) {
                    this.spinnerService.hide();
                    this.onJumpToDate(soonest);
                } else {
                    this.onJumpToDate(new Date(this.month1.toISOString()));
                }
            }, error => {
                this.spinnerService.hide();
                this.onJumpToDate(new Date(this.month1.toISOString()));
            });
    }


    private onPopoverDateSelected(date: any) {
        if (Date.parse(date)) {
            this.onJumpToDate(new Date(date));
            this.refreshSchedule();
        }
    }

    private addMonth(dateToChange: Date) {
        // if it is not December advance the month by 1
        if (dateToChange.getMonth() !== 11) {
            const changedDate = mainMoment(dateToChange).add(1, 'months').toDate();
            // dateToChange.setMonth(dateToChange.getMonth() + 1);
            dateToChange.setDate(changedDate.getDate());
            dateToChange.setMonth(changedDate.getMonth());
        } else {
            // if it is December set the month to January and advance the year by 1
            dateToChange.setMonth(0);
            dateToChange.setFullYear(dateToChange.getFullYear() + 1);
        }
    }

    private subtractMonth(dateToChange: Date) {
        // if it is not January decrement the display month by 1
        if (dateToChange.getMonth() !== 0) {
            // dateToChange.setMonth(dateToChange.getMonth() - 1);
            const changedDate = mainMoment(dateToChange).subtract(1, 'months').toDate();
            dateToChange.setDate(changedDate.getDate());
            dateToChange.setMonth(changedDate.getMonth());
        } else {
            // if it is January set the month to December and decrement the year by 1
            dateToChange.setMonth(11);
            dateToChange.setFullYear(dateToChange.getFullYear() - 1);
        }
    }

    private setTranslation() {
        if (this.numApptFilter == 1) {
            this.translate.get('SCHEDULE_INTERVIEW.DATE.APPOINTMENTS').subscribe(res => {
                this.numAvailable = res;
                this.numNotAvailable = res;
            });
        } else {
            this.translate.get('SCHEDULE_INTERVIEW.DATE.APPOINTMENTS_AVAILABLE', {value: this.numApptFilter}).subscribe(res => {
                this.numAvailable = res;
            });
            this.translate.get('SCHEDULE_INTERVIEW.DATE.FEWER', {value: this.numApptFilter}).subscribe(res => {
                this.numNotAvailable = res;
            });
        }
    }

}
